var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84685 4.84685C5.30931 4.38438 6.05911 4.38438 6.52157 4.84685L12 10.3253L14.7392 7.58606L17.4784 4.84685C17.9409 4.38438 18.6907 4.38438 19.1531 4.84685C19.6156 5.30931 19.6156 6.05911 19.1531 6.52157L13.6747 12L19.1531 17.4784C19.6156 17.9409 19.6156 18.6907 19.1531 19.1531C18.6907 19.6156 17.9409 19.6156 17.4784 19.1531L12 13.6747L6.52157 19.1532C6.05911 19.6156 5.30931 19.6156 4.84685 19.1532C4.38438 18.6907 4.38438 17.9409 4.84685 17.4784L10.3253 12L4.84685 6.52157C4.38438 6.05911 4.38438 5.30931 4.84685 4.84685Z",
    fill: "#1A1A1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.d092ce9e47a785373ff493c753857da5.svg";
export { ForwardRef as ReactComponent };